import { Actions, createNamespace } from "../../../../flux/Actions";
import { Division } from "../../../../models";

const ns = createNamespace('EDIT_SERVICE_ACCOUNT');
export const names = {
    SET_DIVISION: ns('SET_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS'),
    SET_LOGIN: ns('SET_LOGIN'),
    SET_PASSWORD: ns('SET_PASSWORD'),
    SET_SERVER_URL: ns('SET_SERVER_URL'),
    SET_IMPORT_VEHICLES: ns('SET_IMPORT_VEHICLES'),
};

export class EditServiceAccountActions extends Actions
{
    setDivision = (division: Division) => this.dispatch(names.SET_DIVISION, division);
    setDivisionItems = (divisions: Division[]) => this.dispatch(names.SET_DIVISION_ITEMS, divisions);
    setLogin = (login: string) => this.dispatch(names.SET_LOGIN, login);
    setPassword = (password: string) => this.dispatch(names.SET_PASSWORD, password);
    setServerUrl = (url: string) => this.dispatch(names.SET_SERVER_URL, url);
    setImportAllVehicles = (flag: boolean) => this.dispatch(names.SET_IMPORT_VEHICLES, flag);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/EditServiceAccountActions.ts